<template>
    <div v-if="show">
       
            <v-col>
                <HeaderCheckList
                    title="Reservatórios"
                    :click="() => create()"
                />
            </v-col>
            <v-row>
                <div v-for="reservoirItem, i in list">
                    <CardCheckList
                        :loading="loadingIndex === i"
                        :view="() => edit(i)"
                        :remove="() => remove(i)"
                    >
                        <template v-slot:content>
                            <div style="
                                padding: 10px;
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                            ">
                                <div>
                                    <h3 style="
                                        font-size: 15px;
                                        color: black;
                                        text-align: center;
                                    ">{{ reservoirItem.locale }}</h3>
                                </div>
                                <div>
                                    <h4 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ reservoirItem.type }}</h4>
                                </div>
                                <div>
                                    <h5 style="
                                        font-size: 12px;
                                        color: black;
                                        text-align: center;
                                    ">{{ reservoirItem.capacity }} L</h5>
                                </div>
                            </div>
                        </template>
                    </CardCheckList>
                </div>
            </v-row>
            <v-dialog transition="dialog-top-transition" v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Reservatório</span></v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text style="padding-bottom: 0px;">
                        <v-form ref="reservoirForm" v-model="isValidForm" lazy-validation>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.locale" 
                                        outlined 
                                        label="Local" 
                                        type="text" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.height" 
                                        outlined 
                                        label="Altura" 
                                        type="Number" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-select 
                                        v-model="reservoir.type" 
                                        outlined 
                                        label="Reservatorio" 
                                        :items="optionsReservoir"
                                        prepend-inner-icon="mdi-cup-water" 
                                        required 
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field 
                                        v-model="reservoir.capacity" 
                                        outlined 
                                        label="Capacidade" 
                                        prefix="L" 
                                        type="Number" 
                                        required
                                        :rules="rulesRequired"
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="reservoir.ifInstallation" 
                                        outlined 
                                        label="Realizar instalação?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="6" v-if="isManagementProposal">
                                    <v-select 
                                        v-model="reservoir.ifLoan" 
                                        outlined 
                                        label="Comodato?"
                                        :items="selectedIf" 
                                        required 
                                    />
                                </v-col>
                                <v-col cols="12" :sm="12">
                                    <v-textarea 
                                        v-model="reservoir.comments" 
                                        outlined 
                                        label="Observação" 
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <v-row dense class="mt-2">
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput"
                                    title="Foto 1"
                                    :refInput="refInput"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="reservoir.file_photo"
                                    @change:file="(file) => handleImageChange(file, 1)"
                                />
                            </v-col>
                            <v-col cols="6">
                                <InputFiles
                                    :key="refInput + 1"
                                    title="Foto 2"
                                    :refInput="refInput + 1"
                                    :loading="false"
                                    :fileTypes="['image']"
                                    :showFile="reservoir.file_photo2"
                                    @change:file="(file) => handleImageChange(file, 2)"
                                />
                            </v-col>
                        </v-row>
                        <!-- <InputImg v-on:rawFiles="rawFiles = $event"/> -->
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDialog()">
                        Cancelar
                        </v-btn>
                        <v-btn :disabled="!isValidForm" color="blue darken-1" text @click="save()"> Adicionar </v-btn>
                    </v-card-actions>
                </v-card>
              </v-dialog>
    </div>
</template>
  
<script>
import HeaderCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/HeaderCheckList.vue"
import CardCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/CardCheckList.vue"
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import InputFiles from "@/components/Forms/Input/input-files.vue";
import cloneDeep from 'lodash/cloneDeep';

import Rules from "@/utils/Rules";

const newReservoir = () => {
    return {
        locale: "",
        type: "",
        height:null,
        file_photo: null,
        path_photo: null,
        file_photo2: null,
        path_photo2: null,
        capacity: "",
        comments: "",
        ifInstallation:false,
        ifLoan:false,
    }
}

export default {
    name: "ReservoirList",
    
    components: {
        HeaderCheckList,
        CardCheckList,
        InputFiles
    },
    
    props: {
        show: {
            type: Boolean,
            default: true
        },
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (hydrometer, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
        desiredProposal: {
            type: Array,
            default: () => []
        }
    },
    
    data: () => ({
        loadingIndex: -1,
        isValidForm: true,
        refInput: new Date().getTime(),
        dialog: false,
        index: -1,
        reservoir: newReservoir(),
        optionsReservoir: ["Superior", "Inferior", "Caixa d'água"],
        selectedIf:[
            {text:"Sim", value:true},
            {text:"Não", value:false},
        ],
    }),
    
    computed: {
        rulesRequired() {
            return Rules.required();
        },
        isManagementProposal(){
            return this.desiredProposal.includes("management")
        },
    },

    methods: {
        create() {
            this.index = -1
            this.reservoir = newReservoir()
            this.refInput = new Date().getTime()
            this.dialog = true
        },
        handleImageChange(file, photoNumber) {
            const fileKey = photoNumber === 1 ? 'file_photo' : 'file_photo2';
            const pathKey = photoNumber === 1 ? 'path_photo' : 'path_photo2';

            if (this.reservoir[fileKey] === file) return;

            if (!file) {
                this.$set(this.reservoir, pathKey, null);
                this.$set(this.reservoir, fileKey, null);
            } else {
                this.$set(this.reservoir, pathKey, null);
                this.$set(this.reservoir, fileKey, file);
            }
        },
        clearImageState() {
            if (this.reservoir) {
                this.reservoir.file_photo = null
                this.reservoir.path_photo = null
                this.reservoir.file_photo2 = null
                this.reservoir.path_photo2 = null
            }
        },
        async edit(index) {
            try {
                this.loadingIndex = index;
                this.index = index
                this.reservoir = cloneDeep(this.list[index])

                if (!this.reservoir.hasOwnProperty('file_photo')) this.$set(this.reservoir, 'file_photo', null)
                if (!this.reservoir.hasOwnProperty('file_photo2')) this.$set(this.reservoir, 'file_photo2', null)

                this.refInput = new Date().getTime()

                if (this.reservoir.path_photo) {
                    try {
                        const file1 = await DiagnosticStorage.downloadImg(this.reservoir.path_photo)
                        this.$set(this.reservoir, 'file_photo', file1)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 1:', error)
                        this.$set(this.reservoir, 'file_photo', null)
                    }
                }

                if (this.reservoir.path_photo2) {
                    try {
                        const file2 = await DiagnosticStorage.downloadImg(this.reservoir.path_photo2)
                        this.$set(this.reservoir, 'file_photo2', file2)
                    } catch (error) {
                        console.error('Erro ao carregar imagem 2:', error)
                        this.$set(this.reservoir, 'file_photo2', null)
                    }
                }

                await this.$nextTick()
                this.dialog = true
            } finally {
                this.loadingIndex = -1;
            }
        },
        save() {
            if (!this.$refs.reservoirForm.validate()) return
            this.add(cloneDeep(this.reservoir), this.index)
            this.dialog = false
            this.clearImageState()
        },
        closeDialog() {
            this.dialog = false
            this.clearImageState()
            if (this.reservoir) {
                this.reservoir.file_photo = null
                this.reservoir.file_photo2 = null
            }
        },
    },

    watch: {
        
    },

};
</script>
  
<style scoped>

</style>
